module.exports = __webpack_public_path__ + "img/pomodoro.8434f737.jpg";